import { RouletteBetType } from "./fixIDS";

export const IMG_URL = "http://127.0.0.1:7773";
// export const IMG_URL = "http://192.168.16.53:7778";
// export const IMG_URL = "https://goa_localnode.profcymadev.com:7779";

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data[name] || data?.id,
    label: data?.address || data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};
export const formatTimeAMPM = (time) => {
  if (!time) return "--";
  const [hours, minutes] = time.split(":");
  let h = Number(hours);
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12; // convert 0 → 12
  return `${h}:${minutes} ${ampm}`;
};
export function formatDateTimeNew(dateStr) {
  const date = new Date(dateStr);

  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" }); // Jan, Feb, etc.
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // Add ordinal suffix to day
  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"],
      v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  // Format time as hh:mm am/pm with leading zeros
  const formatTime = (h, m) => {
    const period = h >= 12 ? "pm" : "am";
    const hour12 = h % 12 || 12;
    const hourStr = hour12 < 10 ? `0${hour12}` : hour12;
    const min = m < 10 ? `0${m}` : m;
    return `${hourStr}:${min} ${period}`;
  };

  return `${getOrdinal(day)} ${month} ${year} | ${formatTime(hours, minutes)}`;
}

export const formatTimeInIST = (date) => {
  const createdAt = new Date(date);
  const options = { hour: "2-digit", minute: "2-digit", hour12: true };
  const istTime = createdAt.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    ...options,
  });
  // setFormattedTime(`${istTime} IST`);
  return istTime;
};

export const calculateTimeAgo = (date) => {
  const createdAt = new Date(date);
  const now = new Date();
  const diffInMilliseconds = now - createdAt;

  const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
  const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

  if (diffInDays >= 1) {
    return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
  } else if (diffInHours >= 1) {
    return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
  } else {
    return `${diffInMinutes} Min Ago`;
  }
};

export const handleDecimalKeyDown = (e) => {
  const allowedKeys = [
    "Backspace",
    "Tab",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
    ".",
    "Home",
    "End",
  ];
  const isNumber = /^[0-9]$/.test(e.key);

  if (!isNumber && !allowedKeys.includes(e.key)) {
    e.preventDefault();
  }

  // Prevent multiple dots
  if (e.key === "." && e.currentTarget.value.includes(".")) {
    e.preventDefault();
  }
};

export const formatDate = (dateString, format = false) => {
  if (!dateString) return "--";
  const date = new Date(dateString);
  if (format) {
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }
  return `${date.toISOString().slice(0, 10)}`; // returns 'YYYY-MM-DD'
};

export const formatAmount = (amount = 0) => {
  return `${new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount) || 0)}`;
};

export const Last_Login = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const options = {
    hour: "2-digit",
    minute: "2-digit",
    // second: '2-digit',
    hour12: true, // Set to true for AM/PM format
  };
  const time = date.toLocaleTimeString("en-US", options);
  return `${date.toISOString().slice(0, 10)} at ${time}`; // returns 2026-01-28 at 07:02 PM
};

export const getDimension = async (file) => {
  let reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    reader.onload = () => {
      var image = new Image();
      image.src = reader.result;
      image.onload = function () {
        resolve({ width: this.width, height: this.height });
      };
    };
    reader.readAsDataURL(file);
  });
};

export const getRouletteBetLabel = (bet) => {
  switch (bet.bet_type_id) {
    case RouletteBetType.Straight:
      return bet.Roulette_Bet_Numbers?.[0]?.number;

    case RouletteBetType.Color:
      return bet.value === "red" ? "Red" : "Black";

    case RouletteBetType.Parity:
      return bet.value === "odd" ? "Odd" : "Even";

    case RouletteBetType.Range:
      return bet.value === "small" ? "1 - 18" : "19 - 36";

    case RouletteBetType.Dozen:
      return {
        first: "1st 12 (1 - 12)",
        second: "2nd 12 (13 - 24)",
        third: "3rd 12 (25 - 36)",
      }[bet.value];

    case RouletteBetType.Row:
      return {
        first: "1st Row",
        second: "2nd Row",
        third: "3rd Row",
      }[bet.value];

    default:
      return "-";
  }
};
